export default __webpack_public_path__ + "static/media/support-notes-logo-forbes.5060f476.svg";